import { proNavigator } from "single-spa/react-app/ProNavigator";

export const getUseDomainsOnly = () => {
    const params = proNavigator.getParams();
    if (!params) {return false;}
    const { useDomainsOnly } = params;
    return isUseDomainsOnly(useDomainsOnly);
};

export const isUseDomainsOnly = (useDomainsOnly: string): boolean => useDomainsOnly === true.toString();
